// IVA chileno (19%). Los precios y costos se registran con IVA incluido, como se pagan y se
// cobran de verdad; de ahí se calcula el neto y el impuesto de cada registro.
import { claveMes } from './format';

export const TASA_IVA = 0.19;

export const DOCUMENTOS_VENTA = [
  { value: 'boleta', label: '🧾 Boleta' },
  { value: 'factura', label: '📄 Factura' },
  { value: 'ninguno', label: 'Sin documento' },
];

const num = (n) => Number(n || 0);

export const netoDesdeTotal = (total) => Math.round(num(total) / (1 + TASA_IVA));
export const ivaDesdeTotal = (total) => Math.round(num(total)) - netoDesdeTotal(total);

// Una venta genera IVA débito si se emitió boleta o factura.
export const conIva = (documento) => documento === 'boleta' || documento === 'factura';

export const nombreDocumento = (documento) =>
  DOCUMENTOS_VENTA.find(d => d.value === documento)?.label || 'Sin documento';

// IVA del mes: débito (lo que cobraste en las ventas) menos crédito (el de las compras con factura).
// El crédito sale de tres lados: entradas de mercadería, compras registradas en Mis Compras y
// salidas de dinero marcadas con factura. Las salidas que pertenecen a una compra o a una entrada
// de stock se excluyen, porque ese IVA ya viene contado por el registro de origen.
export function ivaDelMes({ clave, ventas = [], compras = [], movStock = [], movimientos = [] }) {
  const delMes = (f) => claveMes(f) === clave;
  const yaContados = new Set([
    ...compras.map(c => c.movimiento_id),
    ...movStock.map(m => m.movimiento_id),
  ].filter(Boolean));

  const ventasMes = ventas.filter(v => delMes(v.fecha) && !v.devuelta);
  const debito = ventasMes.reduce((s, v) => s + num(v.iva), 0);

  const mercaderiaMes = movStock.filter(m => delMes(m.fecha) && num(m.iva) > 0);
  const comprasMes = compras.filter(c => delMes(c.fecha) && num(c.iva) > 0);
  const gastosMes = movimientos.filter(m =>
    m.tipo === 'egreso' && delMes(m.fecha) && num(m.iva) > 0 && !yaContados.has(m.id));

  const creditoMercaderia = mercaderiaMes.reduce((s, m) => s + num(m.iva), 0);
  const creditoCompras = comprasMes.reduce((s, c) => s + num(c.iva), 0);
  const creditoGastos = gastosMes.reduce((s, m) => s + num(m.iva), 0);

  return {
    debito,
    credito: creditoMercaderia + creditoCompras + creditoGastos,
    saldo: debito - (creditoMercaderia + creditoCompras + creditoGastos),
    creditoMercaderia,
    creditoCompras,
    creditoGastos,
    ventasMes,
    mercaderiaMes,
    comprasMes,
    gastosMes,
  };
}
